import { InjectionToken } from '@angular/core';
import { IAppConfiguration } from '@mnz-core/models/app-configuration';

/**
 * Provides the APP configuration mainly loaded from window.config
 */
export const APP_CONFIG = new InjectionToken<IAppConfiguration>('APP_CONFIG', {
  providedIn: 'root',
  factory: () => Object()
});
